// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"301d553a","343":"59a489cb","367":"50bb85c7","451":"e307b89d","495":"fb8c2125","819":"47fd43ca","969":"639a492a","989":"e606e1e7"}[chunkId] + ".chunk.js";
};